import API from 'app/utils/apiClient';
import { toParams } from 'app/utils/url';

const getNotices = (category, service) => {
  const params = toParams({
    category,
    service,
  });

  return API.get(`/notices/?${params}`);
};

const getNotice = (id) => API.get(`/notices/${id}/`);

export default {
  getNotices,
  getNotice,
};



// WEBPACK FOOTER //
// ./src/app/apis/notice.js